export const calculatePercentFromNumber = (number: number, percent: number) => {
  return Math.floor((number * percent) / 100);
};
